var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ws-select-search',_vm._g(_vm._b({staticClass:"w-full",attrs:{"multiple-filter-split":";","filter-placeholder":_vm.$t('common.splitSemicolon')}},'ws-select-search',_vm.$attrs,false),_vm.$listeners),[_c('span',{attrs:{"slot":"prefix"},slot:"prefix"},[_vm._v(_vm._s(_setup.label)+_vm._s(_vm.$t('common.colon')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }